export default __webpack_public_path__ + "static/media/detail-4.b994c940.png";